export default class NewsFeedPost {
  constructor (raw) {
    this.id = raw.id
    this.post_type = raw.post_type || 'post'
    this.created_by = raw.created_by
    this.store_id = raw.store_id
    this.retail_name_store_name = raw.retail_name_store_name
    this.created_at = raw.created_at
    this.cat_description = raw.cat_description
    this.name = raw.name
    this.content = raw.content
    this.is_deleted = raw.is_deleted
    this.deleted_at = raw.deleted_at
    this.deleted_by_name = raw.deleted_by_name
    this.latest_comment_content = raw.latest_comment_content
    this.latest_comment_author = raw.latest_comment_author
    this.latest_comment_at = raw.latest_comment_at
    this.hashtags = raw.hashtags || []
    this.mentions = raw.mentions || []
    this.latitude = raw.latitude ?? null
    this.longitude = raw.longitude ?? null
    this.checked_in_at = raw.checked_in_at ?? null
    this.check_in_id = raw.check_in_id ?? null
    this.retail_product = raw.retail_product ?? null
    this.vendor_product = raw.vendor_product ?? null
    this.total = raw.total
    this.per_page = raw.per_page
  }

  get isCheckEvent () {
    return this.post_type === 'check_in' || this.post_type === 'check_out'
  }

  get isCheckIn () {
    return this.post_type === 'check_in'
  }

  get isCheckOut () {
    return this.post_type === 'check_out'
  }

  get hasCoordinates () {
    return this.latitude !== null && this.longitude !== null
  }

  get visitDuration () {
    if (!this.isCheckOut || !this.checked_in_at || !this.created_at) return null
    const minutes = Math.round((this.created_at - this.checked_in_at) / 1000 / 60)
    if (minutes < 60) return `${minutes} min`
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60
    return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}min` : `${hours}h`
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/NewsFeedPost.js